module.exports = "//public.zight.com/packs/media/images/team_sidebar-d895b5876aea87547e56c88a722352e7.png";